import { render, staticRenderFns } from "./member-info.vue?vue&type=template&id=2d916bac&scoped=true"
import script from "./member-info.vue?vue&type=script&lang=js"
export * from "./member-info.vue?vue&type=script&lang=js"
import style0 from "./member-info.vue?vue&type=style&index=0&id=2d916bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d916bac",
  null
  
)

export default component.exports